import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/FacetFieldConfigurations.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/v2/configurations/facets/fields`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	create(e) {
		return this.api.post(n.baseUrl, e);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	generate(e) {
		return this.api.post(this.buildPath(`${n.baseUrl}/generate`, { trackingId: e }));
	}
};
export { n as FacetFieldConfigurations };

//# sourceMappingURL=FacetFieldConfigurations.js.map